import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TeacherWithBoardIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47 47",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47),
    children: [/*#__PURE__*/jsx("circle", {
      cx: "10",
      cy: "7",
      r: "6"
    }), /*#__PURE__*/jsx("path", {
      d: "M10 16v12M14.5 46L16 31h3v-6a9 9 0 10-18 0v6h3l1.5 15zM25 32.5h18a3 3 0 003-3V4a3 3 0 00-3-3H22"
    })]
  });
};

export { PM2TeacherWithBoardIcon };
//# sourceMappingURL=teacher-with-board.js.map
